// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Form from '../../ui/components/Forms/Register';
import { registerUser, getRegisterFields, getSocialUrls } from '../../actions';

type Props = {
    clientID: string,
    language: string,
    social: Array<any>,
    registerFields: Array<any>,
    isLoading: boolean,
    branding: Object,
    params: Object,
    registerUser: Function,
    getRegisterFields: Function,
    getSocialUrls: Function,
};

type State = {
    name: string,
    active: boolean,
};

export class Register extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            active: false,
        };
    }

    componentDidMount() {
        //call because registerFields array is empty after user logout
        this.props.getRegisterFields();
        this.props.getSocialUrls();
    }

    handleRegister = (data: Object) => {
        if (this.props.isLoading) return;

        this.props.registerUser(data);
    };

    handleFocus = e => {
        e.preventDefault();
        this.setState({
            name: e.target.name,
            active: !this.state.active,
        });
    };

    render() {
        const {
            social,
            registerFields,
            language,
            branding,
            params,
            isLoading,
        } = this.props;

        return (
            <Form
                social={social}
                registerFields={registerFields}
                onSubmit={this.handleRegister}
                lng={language}
                branding={branding}
                params={params}
                handleFocus={this.handleFocus}
                active={this.state.active}
                name={this.state.name}
                isLoading={isLoading}
            />
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        clientID: state.paywall.clientID,
        social: state.auth.socialUrls,
        registerFields: state.auth.registerFields,
        language: state.auth.language,
        branding: state.branding,
        params: state.form.registerForm,
        isLoading: state.auth.isLoadingButton,
    };
};

export default connect(
    mapStateToProps,
    {
        registerUser,
        getRegisterFields,
        getSocialUrls,
    }
)(Register);



// WEBPACK FOOTER //
// ./src/containers/Forms/Register.js